import { render, staticRenderFns } from "./ShowTerminalsTef.vue?vue&type=template&id=3b0c1a1d"
import script from "./ShowTerminalsTef.vue?vue&type=script&lang=js"
export * from "./ShowTerminalsTef.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports